import type NewsSignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsSignalFilters";
import type { SignalTimeframe, SignalTimeframeConfig } from "../miscellaneous/SignalTimeframe";
import { SignalTimeframePeriod } from "../miscellaneous/SignalTimeframe";

const newsSignalTimeframeConfig: SignalTimeframeConfig<NewsSignalFilters> = {
    options: [
        {
            amount: 1,
            id: SignalTimeframePeriod.Day,
        },
        {
            amount: 1,
            id: SignalTimeframePeriod.Week,
        },
        {
            amount: 2,
            id: SignalTimeframePeriod.Week,
        },
        {
            amount: 3,
            id: SignalTimeframePeriod.Week,
        },
        {
            amount: 1,
            id: SignalTimeframePeriod.Month,
        },
    ],
    fromFilters(filters: Readonly<Partial<NewsSignalFilters>>) {
        const { period, periodAmount } = filters;

        if (period == null || periodAmount == null) {
            return undefined;
        }

        return { amount: periodAmount, id: period };
    },
    toFilters(timeframe: Readonly<SignalTimeframe>) {
        return {
            period: timeframe.id as SignalTimeframePeriod,
            periodAmount: timeframe.amount,
        };
    },
};

export default newsSignalTimeframeConfig;
